"use client";
import {
  hasRequestedProgram,
  setLastRequestProgram,
  setRequestProgram,
} from "@/app/(main)/voyage/[aliasId]/_components/RequestProgram/lastRequestProgram";
import { useRequestProgramFITMutation } from "@/app/api/request-program-fit/front";
import { authClient } from "@/lib/authClient";
import { getUserInfo } from "@/lib/userInfo";
import { type PropsWithChildren, useState } from "react";
import { Form } from "./Form";

export type RequestProgramFITTravelImage = {
  id: number;
  realname: string;
  name: string;
  caption: string;
} | null;

type Props = {
  travelId: number;
  travelTitle: string;
  travelImage: RequestProgramFITTravelImage;
  travelCountries: Array<{ title: string; alias: string | null }>;
  programUrl: string;
  className?: string;
};
export const RequestProgramFIT = ({
  travelId,
  travelTitle,
  travelImage,
  travelCountries,
  programUrl,
  className,
  children,
}: PropsWithChildren<Props>) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [request] = useRequestProgramFITMutation();

  const openProgram = () => {
    const a = document.createElement("a");
    a.href = programUrl;
    a.target = "_blank";
    a.click();
    a.remove();
  };

  const handleClick = async () => {
    if (isLoading) return;

    setIsLoading(true);

    try {
      const { data } = await authClient.getSession();

      if (data !== null) {
        setLastRequestProgram();
        setRequestProgram();
        request({
          type: "authenticated",
          travelId,
        });
        openProgram();
        return;
      }

      const userInfo = await getUserInfo();

      if (userInfo) {
        setLastRequestProgram();
        setRequestProgram();
        request({
          type: "anonymous",
          email: userInfo.email,
          phone: userInfo.telephone,
          travelId,
        });
        openProgram();
        return;
      }

      if (hasRequestedProgram()) {
        setLastRequestProgram();
        openProgram();
        return;
      }

      setIsOpen(true);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div onClick={handleClick} className={className}>
        {children}
      </div>
      {isOpen && (
        <Form
          travelId={travelId}
          travelTitle={travelTitle}
          travelImage={travelImage}
          travelCountries={travelCountries}
          programUrl={programUrl}
          onHide={() => setIsOpen(false)}
        />
      )}
    </>
  );
};
